/**
 * @typedef {{
 *   fcEventId: string,
 *   title: string,
 *   kind: 'weekly-meeting' | 'event',
 *   source?: 'club-event' | 'meeting' | string,
 *   sourceId?: string,
 *   startIso?: string,
 *   endIso?: string,
 *   allDay?: boolean,
 *   preview?: {
 *     city?: string,
 *     location?: string,
 *     meetingRoomName?: string,
 *   },
 * }} CalendarEventSelection
 */

/**
 * @param {Record<string, unknown>} ext
 */
function readPreview(ext) {
    return {
        city: ext.city != null ? String(ext.city) : '',
        location: ext.location != null ? String(ext.location) : '',
        meetingRoomName:
            ext.meetingRoomName != null ? String(ext.meetingRoomName) : '',
    };
}

/**
 * FullCalendar tıklamasından seçim nesnesi üretir.
 * @param {import('@fullcalendar/core').EventApi} event
 * @returns {CalendarEventSelection}
 */
export function selectionFromFullCalendarEvent(event) {
    const ext =
        event.extendedProps && typeof event.extendedProps === 'object'
            ? /** @type {Record<string, unknown>} */ (event.extendedProps)
            : {};

    const kind =
        ext.kind === 'weekly-meeting' ? 'weekly-meeting' : 'event';

    let sourceId =
        ext.sourceId != null ? String(ext.sourceId).trim() : '';
    const fcEventId = String(event.id ?? '');
    if (!sourceId) {
        if (fcEventId.startsWith('club-')) {
            sourceId = fcEventId.slice(5);
        } else if (fcEventId.startsWith('meet-')) {
            sourceId = fcEventId.slice(5);
        }
    }

    return {
        fcEventId,
        title: String(event.title || ''),
        kind,
        source: ext.source != null ? String(ext.source) : undefined,
        sourceId: sourceId || undefined,
        startIso: event.start ? event.start.toISOString() : undefined,
        endIso: event.end ? event.end.toISOString() : undefined,
        allDay: event.allDay,
        preview: readPreview(ext),
    };
}

/**
 * @param {import('./calendarAgenda').AgendaInstance} item
 * @returns {CalendarEventSelection}
 */
export function selectionFromAgendaItem(item) {
    return {
        fcEventId: item.fcEventId,
        title: item.title,
        kind: item.kind,
        source: item.source,
        sourceId: item.sourceId,
        startIso: item.startIso,
        endIso: item.endIso,
        allDay: item.allDay,
        preview: item.preview,
    };
}
